import { MailOutlined, MoreOutlined, WhatsAppOutlined } from "@ant-design/icons"
import { Button, Dropdown, Flex, Tooltip } from "antd"
import { type ItemType } from "antd/es/menu/interface"
import React from "react"
import { useTranslation } from "react-i18next"

import { openMailto } from "../../../../../utils/open-mailto.ts"
import { type Lead } from "../../../types/lead.types.ts"
import { leadQuickActionTargets, whatsAppLink } from "./lead-quick-actions.ts"

interface LeadWorkspaceQuickActionsProps {
  lead: Lead
  moreItems: ItemType[]
}

export function LeadWorkspaceQuickActions({
  lead,
  moreItems
}: LeadWorkspaceQuickActionsProps) {
  const { t } = useTranslation()
  const { phone, email, available } = leadQuickActionTargets(lead)

  return (
    <Flex gap={8} align={"center"} wrap>
      {available.includes("whatsapp") && (
        <Tooltip
          title={t("leadWorkspace.header.actions.whatsAppNumber", { phone })}
        >
          <Button
            aria-label={t("leadWorkspace.header.actions.whatsApp")}
            size={"large"}
            className={"rounded-lg"}
            icon={<WhatsAppOutlined />}
            onClick={() =>
              window.open(whatsAppLink(phone!), "_blank", "noopener")
            }
          />
        </Tooltip>
      )}

      {available.includes("email") && (
        <Tooltip
          title={t("leadWorkspace.header.actions.emailAddress", { email })}
        >
          <Button
            aria-label={t("leadWorkspace.header.actions.email")}
            size={"large"}
            className={"rounded-lg"}
            icon={<MailOutlined />}
            onClick={() => openMailto(email!)}
          />
        </Tooltip>
      )}

      {!!moreItems.length && (
        <Dropdown trigger={["click"]} menu={{ items: moreItems }}>
          <Button
            aria-label={t("leadWorkspace.header.actions.more")}
            size={"large"}
            className={"rounded-lg"}
            icon={<MoreOutlined />}
          />
        </Dropdown>
      )}
    </Flex>
  )
}
